import { TFunction } from "next-i18next";
import { UTSLocale } from "@smile2impress/attraction-constants";
import { SmileVisionOfferContent } from "layouts/relaunch/pages/SmileVisionOffer/SmileVisionOfferLayout.types";

import { OFFERS_AND_DISCOUNTS_LINKS_BY_LOCALE } from "configs/urlsConfig";
import { UrlsConfig } from "configs/urlsConfig";
import { getWALink } from "utils/getWALink";

const SMILE_VISION_OFFER_WHATSAPP_URL_BY_LOCALE: Partial<
    Record<UTSLocale, string>
> = {
    [UTSLocale.FRANCE_FR]: `${UrlsConfig.WHATSAPP_BASE_URL}/33743390376`,
    [UTSLocale.GERMANY_DE]: `${UrlsConfig.WHATSAPP_BASE_URL}/493031193865`,
    [UTSLocale.SPAIN_ES]: `${UrlsConfig.WHATSAPP_BASE_URL}/34610980285`,
    [UTSLocale.ITALY_IT]: `${UrlsConfig.WHATSAPP_BASE_URL}/393494727274`,
    [UTSLocale.PORTUGAL_PT]: `${UrlsConfig.WHATSAPP_BASE_URL}/351913811027`,
    [UTSLocale.GB_EN]: `${UrlsConfig.WHATSAPP_BASE_URL}/447535801054`,
    [UTSLocale.NL_NL]: `${UrlsConfig.WHATSAPP_BASE_URL}/31708080714`,
};

const pageContent = (
    t: TFunction,
    { locale }: { locale: UTSLocale }
): SmileVisionOfferContent => {
    const whatsAppUrl = SMILE_VISION_OFFER_WHATSAPP_URL_BY_LOCALE[locale];
    const ctaHref = whatsAppUrl
        ? getWALink(whatsAppUrl, t("smileVisionOffer:ctaWhatsAppMessage"))
        : OFFERS_AND_DISCOUNTS_LINKS_BY_LOCALE[locale] ?? UrlsConfig.DISCOUNT;

    return {
        headline: t("smileVisionOffer:headline"),
        description: t("smileVisionOffer:description"),
        photoTabLabel: t("smileVisionOffer:photoTabLabel"),
        videoTabLabel: t("smileVisionOffer:videoTabLabel"),
        mediaExpiredMessage: t("smileVisionOffer:mediaExpiredMessage"),
        beforeLabel: t("smileVisionOffer:beforeLabel"),
        afterLabel: t("smileVisionOffer:afterLabel"),
        priceBlockTitle: t("smileVisionOffer:priceBlockTitle"),
        fullPriceLabel: t("smileVisionOffer:fullPriceLabel"),
        finalPriceLabel: t("smileVisionOffer:finalPriceLabel"),
        priceBlockClaims: [
            t("smileVisionOffer:priceBlockClaim1"),
            t("smileVisionOffer:priceBlockClaim2"),
            t("smileVisionOffer:priceBlockClaim3"),
        ],
        priceBlockClaim3Disclaimer: t(
            "smileVisionOffer:priceBlockClaim3Disclaimer"
        ),
        ctaPrimaryText: t("smileVisionOffer:ctaPrimaryText"),
        ctaSecondaryText: t("smileVisionOffer:ctaSecondaryText"),
        footnote1: t("smileVisionOffer:footnote1"),
        footnote2: t("smileVisionOffer:footnote2"),
        ctaHref,
    };
};

export default pageContent;
